// src/foundation/color/neutralDay.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
var neutralDay = (_obj = {}, _define_property(_obj, "white" /* White */ , "#FFFFFF"), _define_property(_obj, "gray0" /* Gray0 */ , "#F6F9FA"), _define_property(_obj, "gray5" /* Gray5 */ , "#F2F6F8"), _define_property(_obj, "gray10" /* Gray10 */ , "#EEF3F6"), _define_property(_obj, "gray20" /* Gray20 */ , "#E4EBF0"), _define_property(_obj, "gray30" /* Gray30 */ , "#D7E0E6"), _define_property(_obj, "gray40" /* Gray40 */ , "#C7D2D8"), _define_property(_obj, "gray50" /* Gray50 */ , "#B4BFC6"), _define_property(_obj, "gray60" /* Gray60 */ , "#9DA7AE"), _define_property(_obj, "gray70" /* Gray70 */ , "#81898F"), _define_property(_obj, "gray80" /* Gray80 */ , "#5F666B"), _define_property(_obj, "gray90" /* Gray90 */ , "#3A3E41"), _define_property(_obj, "gray95" /* Gray95 */ , "#25282A"), _define_property(_obj, "gray100" /* Gray100 */ , "#141617"), _obj);
export { neutralDay };
